import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import { getSpecificDateWithDays } from "../../../core/et3-date";
import { TKhattabatAdminsRemunerations } from "../../../TypesNEW";
import { apiCallGetKhattabasRemunerations } from "../../../api/khattbat-api/api-call-get-khattabats-remunerations";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

class KhattabatRemunerationStore {
  remunerationCycleFrom = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 5, daysAdded: 0 })
  );

  remunerationCycleTo = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 0, daysAdded: 1 })
  );

  khattabatAdminsRemunerations = observable.box<TKhattabatAdminsRemunerations>(
    []
  );

  setKhattabatAdminsRemunerations = (
    remunerations: TKhattabatAdminsRemunerations
  ) => {
    runInAction(() => {
      this.khattabatAdminsRemunerations.set(remunerations);
    });
  };

  getKhattabatRemunerationsDatabase = async () => {
    getCoreUIStore().setIsLoading("KHATTABAT_REMUNERATION", true);
    const { data, code, status } = await apiCallGetKhattabasRemunerations({
      remunerationCycleFrom: this.remunerationCycleFrom.get(),
      remunerationCycleTo: this.remunerationCycleTo.get()
    });
    getCoreUIStore().setIsLoading("KHATTABAT_REMUNERATION", false);

    if (status === "OK") {
      this.setKhattabatAdminsRemunerations(data);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

export const getKhattabatRemunerationStore = memoize(
  () => {
    return new KhattabatRemunerationStore();
  },
  () => 1
);

export default getKhattabatRemunerationStore;
